import styled from 'styled-components';

export const CustomToast = styled.div`
	left: 50%;
	gap: 12px;
	top: 20px;
	z-index: 1000;
	display: flex;
	position: fixed;
	padding: 16px 20px;
	align-items: center;
	transform: translateX(-50%);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	background: ${({ theme }) => theme.colors.risk.high};
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
`;

export const WarningIcon = styled.div`
	display: flex;
	align-items: center;
	color: ${({ theme }) => theme.palette.secondary.white};

	svg {
		color: ${({ theme }) => theme.palette.secondary.white};
	}
`;

export const ToastMessage = styled.span`
	color: ${({ theme }) => theme.palette.secondary.white};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
`;
